import { useContext } from 'react';

import { FloatingAlertContext } from '../context/floating-alert';

export const useFloatingAlert = () => {
	const context = useContext(FloatingAlertContext);
	return context;
};
